module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "//www.liveinternet.ru/click",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "//counter.yadro.ru/logo?44.6",
      "title": "LiveInternet",
      "alt": "",
      "border": "0",
      "width": "31",
      "height": "31"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-248e5d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountersBlock.vue
// module id = 1000
// module chunks = 1